module.exports = __webpack_public_path__ + "img/plotNotFound.e3646eb1.png";